module.exports = __webpack_public_path__ + "img/favonius-codex.c9af5543.webp";